(ns common.schema.entities.pre-exit-check
  (:require
   [common.schema.entities.common :as common]
   [common.schema.schema-utils :as su]
   [common.util :as cu]))

(def status-options
  [{:key   :pre-exit-check.status/not-approved
    :value :pre-exit-check.status/not-approved
    :label "Not approved"}
   {:key   :pre-exit-check.status/conditionally-approved
    :value :pre-exit-check.status/conditionally-approved
    :label "Conditionally approved"}
   {:key   :pre-exit-check.status/approved
    :value :pre-exit-check.status/approved
    :label "Approved"}])

(defn status-label
  [k]
  (->> status-options
       (cu/filter-by :key k)
       (first)
       :label))

(def schema
  (concat
   (su/keyword-field :pre-exit-check/status
                     "Status"
                     status-options
                     {:authorization su/access-user-user})
   (su/date-field :pre-exit-check/checked-on
                  "Checked at"
                  {:authorization su/access-user-user})
   (su/text-simple-field :pre-exit-check/conditions
                         "Conditions"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use})
   (su/text-simple-field :pre-exit-check/note
                         "Comment"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use})
   common/attachment-schema))
